import { EWCType } from '../../../../api-models/common/json_query';

export const WC_TYPE_MAP_VALUE_TO_LABEL = {
  [EWCType.Separated]: 'Раздельный',
  [EWCType.United]: 'Совмещенный',
};
